import { render, staticRenderFns } from "./OrderUpdate.vue?vue&type=template&id=5ee6f912&scoped=true"
import script from "./OrderUpdate.vue?vue&type=script&lang=js"
export * from "./OrderUpdate.vue?vue&type=script&lang=js"
import style0 from "./OrderUpdate.vue?vue&type=style&index=0&id=5ee6f912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee6f912",
  null
  
)

export default component.exports